var _rect, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 1500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 2000,
    height: 1500
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    strokeWidth: 1.5,
    strokeOpacity: 1,
    id: "a",
    x: -400,
    y: -300,
    width: 800,
    height: 600
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      transformOrigin: "center"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      transformOrigin: "center"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-160 0 0)",
    style: {
      transformOrigin: "center"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1000 750)"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#000",
    href: "#a",
    transform: "rotate(10 0 0) scale(1.1)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#2e1000",
    href: "#a",
    transform: "rotate(20 0 0) scale(1.2)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#341e00",
    href: "#a",
    transform: "rotate(30 0 0) scale(1.3)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#3d2b00",
    href: "#a",
    transform: "rotate(40 0 0) scale(1.4)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#483800",
    href: "#a",
    transform: "rotate(50 0 0) scale(1.5)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#554500",
    href: "#a",
    transform: "rotate(60 0 0) scale(1.6)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#645300",
    href: "#a",
    transform: "rotate(70 0 0) scale(1.7)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#746100",
    href: "#a",
    transform: "rotate(80 0 0) scale(1.8)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#847000",
    href: "#a",
    transform: "rotate(90 0 0) scale(1.9)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#957f00",
    href: "#a",
    transform: "rotate(100 0 0) scale(2)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#a68e00",
    href: "#a",
    transform: "rotate(110 0 0) scale(2.1)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#b89d0c",
    href: "#a",
    transform: "rotate(120 0 0) scale(2.2)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#c9ad25",
    href: "#a",
    transform: "rotate(130 0 0) scale(2.3)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#dbbd37",
    href: "#a",
    transform: "rotate(140 0 0) scale(2.4)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#edcd48",
    href: "#a",
    transform: "rotate(150 0 0) scale(2.5)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFDE59",
    href: "#a",
    transform: "rotate(160 0 0) scale(2.6)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.999ec15ea072264673a82588b9627580.svg";
export { ForwardRef as ReactComponent };